import React from "react";

interface BreadCrumbProps {
    title: string;
    parent: string;
    child: string;
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({ title, parent, child }) => {
    return (
        <section className="page_breadcrumbs ls ms ms_dark section_padding_25">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 text-center">
                        <h1 className="highlight2 bold bottommargin_5">{title}</h1>
                        <ol className="breadcrumb">
                            <li>
                                <a href="./">
                                    Anasayfa
                                </a>
                            </li>
                            <li>
                                <a href="#">{parent}</a>
                            </li>
                            <li className="active"> {child}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BreadCrumb;